import { gql, useQuery } from '@apollo/client';

import { Group } from '@work4all/models/lib/Classes/Group.entity';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

export const QUERY_NAME_BY_ENTITY: Partial<Record<Entities, string>> = {
  projectGroup: 'getProjektGruppen',
  textBuildingBlockGroup: 'getTextModuleGroups',
  articleGroup: 'getArtikelGruppen',
  customerGroup: 'getKundenGruppen',
  supplierGroup: 'getLieferantenGruppen',
  userGroup: 'getObjectProtectionGroups',
  contractGroup: 'getServiceContractGroups',
  documentTemplateGroup: 'getDocumentTemplateGroups',
  letterTemplateGroup: 'getLetterTemplateGroups',
  salesOpportunityGroup: 'getSalesOpportunityGroups',
};

const getGroupsQuery = (queryName: string) => gql`
    query ${queryName} {
        groups: ${queryName} {
          id: code
          name: name
          parentId: parentCode
          index
        }
    }
  `;

const getUserGroupsQuery = (queryName: string, groupIndexLabel: string) => gql`
    query ${queryName} {
      groups: ${queryName} {
        id: code
        name: name
        index: ${groupIndexLabel}
      }
    }
  `;

export const getQuery = (entity: Entities, queryName: string) => {
  switch (entity) {
    case Entities.userGroup:
      return getUserGroupsQuery(queryName, 'grIndex');
    case Entities.letterTemplateGroup:
      return getUserGroupsQuery(queryName, 'groupIndex');
    case Entities.documentTemplateGroup:
      return getUserGroupsQuery(queryName, 'groupIndex');
    default:
      return getGroupsQuery(queryName);
  }
};

interface GetGroupsResponse {
  groups: Group[];
}

export function useGroups(entity: Entities) {
  const queryName = QUERY_NAME_BY_ENTITY[entity];

  if (!queryName) {
    throw new Error(
      `Entity ${entity} is not defined inside "QUERY_NAME_BY_ENTITY".`
    );
  }

  const query = getQuery(entity, queryName);

  return useQuery<GetGroupsResponse>(query);
}
